import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import WarningAmber from '@mui/icons-material/WarningAmber';
import { HARI_PERINGATAN, formatTanggal } from './langgananUtil';

const KUNCI = 'langganan_banner_ditutup';

// Bilah di paling atas layar (seperti pengumuman langganan): merah saat expired, kuning mulai 30 hari
// sebelum berakhir. Bisa ditutup untuk sesi tab ini; muncul lagi bila statusnya berubah.
const LanggananBanner = () => {
  const { user } = useSelector((state) => state.auth);
  const lg = user?.langganan;
  const status = !lg || lg.permanen ? null : lg.expired ? 'expired' : lg.sisaHari <= HARI_PERINGATAN ? 'segera' : null;
  const tanda = status ? `${status}-${lg.masaAktifSampai}` : '';

  const [ditutup, setDitutup] = useState(() => {
    try { return sessionStorage.getItem(KUNCI) === tanda; } catch (e) { return false; }
  });
  useEffect(() => {
    try { setDitutup(sessionStorage.getItem(KUNCI) === tanda); } catch (e) { setDitutup(false); }
  }, [tanda]);

  if (!status || ditutup) return null;

  const tutup = () => {
    try { sessionStorage.setItem(KUNCI, tanda); } catch (e) { /* abaikan */ }
    setDitutup(true);
  };

  const expired = status === 'expired';
  const judul = expired
    ? 'Masa aktif cabang Anda sudah berakhir'
    : `Masa aktif cabang Anda berakhir ${lg.sisaHari === 1 ? 'besok' : `dalam ${lg.sisaHari} hari`}`;
  const keterangan = expired
    ? `Berakhir pada ${formatTanggal(lg.masaAktifSampai)}. Akun staf tidak bisa login dan Anda hanya bisa melihat data. Perpanjang agar semua fitur aktif kembali.`
    : `Berakhir pada ${formatTanggal(lg.masaAktifSampai)}. Perpanjang sekarang agar kasir dan staf tetap bisa bekerja tanpa gangguan.`;

  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1,
        color: '#fff',
        bgcolor: expired ? '#7f1d1d' : '#92400e',
        borderBottom: `1px solid ${expired ? '#b91c1c' : '#d97706'}`,
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
      }}
    >
      {expired ? <ErrorOutline sx={{ color: '#fecaca' }} /> : <WarningAmber sx={{ color: '#fde68a' }} />}
      <Box sx={{ flex: 1, minWidth: 200 }}>
        <Typography variant="subtitle2" fontWeight={700}>{judul}</Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>{keterangan}</Typography>
      </Box>
      {lg.kontak && (
        <Button
          variant="contained"
          size="small"
          href={lg.kontak.waLink}
          target="_blank"
          rel="noreferrer"
          sx={{ bgcolor: expired ? '#dc2626' : '#d97706', '&:hover': { bgcolor: expired ? '#b91c1c' : '#b45309' }, whiteSpace: 'nowrap' }}
        >
          Perpanjang
        </Button>
      )}
      <IconButton size="small" onClick={tutup} aria-label="Tutup" sx={{ color: '#fff' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default LanggananBanner;
